<template>
  <div id="app">
    <Header />
    <Nav />
    <div class="app-content">
      <transition name="fade-transform" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
    <Friendship />
    <Footer />
    <CopyRight />
  </div>
</template>

<script>
import Header from './views/layout/Header.vue'
import Footer from './views/layout/Footer.vue'
import CopyRight from './views/layout/CopyRight.vue';
import Friendship from './views/layout/Friendship.vue'
import Nav from './views/layout/Nav.vue'
import config from './config';

export default {
  name: 'app',
  components: {
    Header,
    Footer,
    CopyRight,
    Friendship,
    Nav
  },
  data () {
    return {
    }
  },
  created () {
    this.initFace("YouSheBiaoTiHei", `${config.publicPath}font/优设标题黑.ttf`);
    this.initFace("DINPro", `${config.publicPath}font/DINPro-Bold.otf`);
    this.initFace("PingFang SC", `${config.publicPath}font/PingFang-Bold.ttf`);
  },
  methods: {
    initFace (fontName, url) {
      const fontFace = new FontFace(fontName, `url(${url}) format('truetype')`, {
        style: 'normal',
        weight: 'normal',
        display: 'swap' /* 在字体下载过程中使用系统字体，提升性能 */
      });
      fontFace.load().then(function(loadedFontFace) {
        console.log('Font loaded successfully', fontName);
        document.fonts.add(loadedFontFace);
      }).catch(function(error) {
        console.error(`Font failed to load(${fontName}):`, error);
      });
    }
  }
}
</script>

<style lang="scss">
.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all 0.2s;
}

.fade-transform-enter-from,
.fade-transform-leave-to {
  opacity: 0;
}

::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background-color: #c0c0c0;
  border-radius: 5px;
}

.text-ellipsis {
  /* 设置具体的宽度 */
  white-space: nowrap;
  /* 禁止文字换行 */
  overflow: hidden;
  /* 溢出部分隐藏 */
  text-overflow: ellipsis;
  /* 超出宽度的文字显示省略号 */
}
#app {
  width: 100%;
  font-size: 14px;
  .app-content {
    width: 1005px;
    margin:  0 auto;
  }
}
body {
  font-family: "Microsoft YaHei", Arial, "宋体";
  font-size: 12px;
  color: #444;
  line-height: 1.6em;
}
</style>
